// Tiny WebAudio synth — no external assets.
// Sounds: place, clear, combo, gameover, hover.

let ctx = null;
let muted = false;

function ensureCtx() {
    if (typeof window === "undefined") return null;
    if (!ctx) {
        const AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return null;
        ctx = new AC();
    }
    if (ctx.state === "suspended") ctx.resume();
    return ctx;
}

function tone({
    freq = 440,
    type = "sine",
    duration = 0.12,
    attack = 0.005,
    release = 0.08,
    gain = 0.18,
    detune = 0,
    sweepTo = null,
}) {
    const ac = ensureCtx();
    if (!ac) return;
    const osc = ac.createOscillator();
    const g = ac.createGain();
    osc.type = type;
    osc.frequency.setValueAtTime(freq, ac.currentTime);
    if (sweepTo) {
        osc.frequency.exponentialRampToValueAtTime(
            sweepTo,
            ac.currentTime + duration
        );
    }
    osc.detune.setValueAtTime(detune, ac.currentTime);
    g.gain.setValueAtTime(0, ac.currentTime);
    g.gain.linearRampToValueAtTime(gain, ac.currentTime + attack);
    g.gain.exponentialRampToValueAtTime(
        0.0001,
        ac.currentTime + duration + release
    );
    osc.connect(g);
    g.connect(ac.destination);
    osc.start();
    osc.stop(ac.currentTime + duration + release + 0.02);
}

export const audio = {
    isMuted: () => muted,
    toggleMute() {
        muted = !muted;
        return muted;
    },
    setMuted(v) {
        muted = !!v;
    },
    unlock() {
        ensureCtx();
    },
    place() {
        if (muted) return;
        tone({ freq: 520, type: "triangle", duration: 0.06, gain: 0.16 });
        tone({
            freq: 780,
            type: "sine",
            duration: 0.05,
            gain: 0.08,
            attack: 0.001,
        });
    },
    pickup() {
        if (muted) return;
        tone({ freq: 660, type: "sine", duration: 0.04, gain: 0.08 });
    },
    invalid() {
        if (muted) return;
        tone({
            freq: 220,
            type: "square",
            duration: 0.08,
            gain: 0.1,
            sweepTo: 140,
        });
    },
    clear(lines = 1) {
        if (muted) return;
        const base = 540 + lines * 120;
        tone({
            freq: base,
            type: "triangle",
            duration: 0.12,
            gain: 0.18,
            sweepTo: base * 1.6,
        });
        tone({
            freq: base * 1.5,
            type: "sine",
            duration: 0.16,
            gain: 0.12,
            attack: 0.005,
            sweepTo: base * 2.2,
        });
    },
    combo(level = 2) {
        if (muted) return;
        const notes = [523, 659, 784, 988, 1175];
        const ac = ensureCtx();
        if (!ac) return;
        for (let i = 0; i < Math.min(level + 1, notes.length); i++) {
            setTimeout(
                () =>
                    tone({
                        freq: notes[i],
                        type: "triangle",
                        duration: 0.1,
                        gain: 0.16,
                    }),
                i * 70
            );
        }
    },
    gameover() {
        if (muted) return;
        tone({
            freq: 440,
            type: "sawtooth",
            duration: 0.22,
            gain: 0.16,
            sweepTo: 120,
        });
        setTimeout(
            () =>
                tone({
                    freq: 220,
                    type: "sawtooth",
                    duration: 0.32,
                    gain: 0.14,
                    sweepTo: 80,
                }),
            180
        );
    },
};
